// core/state/websocketStore.ts
type WsConn = { url: string; timestamp: number } | null;

let current: WsConn = JSON.parse(
  localStorage.getItem('websocketConnection') || 'null',
);

const listeners = new Set<() => void>();

// --- external‑store API ---
export const websocketStore = {
  get: (): WsConn => current,
  set: (url: string) => {
    current = { url, timestamp: Date.now() };
    localStorage.setItem('websocketConnection', JSON.stringify(current));
    listeners.forEach((l) => l());
  },
  clear: () => {
    current = null;
    localStorage.removeItem('websocketConnection');
    listeners.forEach((l) => l());
  },
  subscribe: (cb: () => void) => {
    listeners.add(cb);
    return () => listeners.delete(cb);
  },
};
